import React from "react";
import styles from "./LoaderComp.module.css";

const LoaderComp = ({ message = "Loading", className = "" }) => {
  const letters = message.split("");
  return (
    <div className={`${styles.card} ${className}`}>
      <div className={styles.loader}></div>
      <div className={styles.loaderDots}>
        {letters.map((char, index) => (
          <span key={index}>{char}</span>
        ))}
        <span className={`${styles.dot} ${styles.blink1}`}>.</span>
        <span className={`${styles.dot} ${styles.blink2}`}>.</span>
        <span className={`${styles.dot} ${styles.blink3}`}>.</span>
      </div>
    </div>
  );
};

export default LoaderComp;
